module.exports = __webpack_public_path__ + "static/img/tax_saas_bg.67348b4.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/matrix/tax_saas_bg.png
// module id = rIWs
// module chunks = 34